import Button from "~/shared/ui/Fields/Button";
import s from "./StaffTrainingFactControl.module.less";
import React from "react";

interface IStaffTrainingControlProps {
  onDownload: () => void;
  disabledControl?: boolean;
}

export const StaffTrainingFactControl = (props: IStaffTrainingControlProps) => {
  const { onDownload, disabledControl } = props;

  return (
    <div>
      <Button
        txtBtn={"Скачать отчет"}
        onClick={onDownload}
        customClassName={s.downloadBtn}
        disabled={disabledControl}
      />
    </div>
  );
};
